import { Value } from '@k3/core'

export const Keys = {
  VSGOffset: {
    Variable: 'vsgOffset',
  },
  VSGBackGlassOffset: {
    Variable: 'vsgBackGlassOffset',
  },
  BackGlassBlackOffset: {
    Variable: 'backGlassBlackOffset',
  },
  BackGlassOffset: {
    Variable: 'backGlassOffset',
  },
  BackgroundColor: {
    Variable: 'backgroundColor',
    Default: '#fff',
  },
  GroundColor: {
    Variable: 'groundColor',
    Default: 'rgb(110, 110, 110)',
  },
  FogDensity: {
    Variable: 'fogDensity',
    Default: 0.025,
  },
  Thickness: {
    Variable: 'thickness',
  },
  FullThickness: {
    Variable: 'fullThickness',
  },
  SolarCellThickness: {
    Variable: 'solarCellThickness',
  },
  PanelDimensions: {
    Variable: 'panelDimensions',
  },
  EFormType: {
    Variable: 'eFormType',
    Value: {
      Clear: 'clear',
      Unichrome: 'unichrome',
      Color: 'color',
    },
  },
  FrontGlassColor: {
    Variable: 'frontGlassColor',
  },
  FrontGlassSurface: {
    Variable: 'frontGlassSurface',
    Value: {
      Glossy: 'glossy',
      Matte: 'matte',
    },
  },
  BackGlassVSG: {
    Variable: 'backGlassVSG',
    Value: {
      Selected: 'selected',
      NotSelected: 'notSelected',
    },
  },
  BackGlassVSGMatte: {
    Variable: 'backGlassVSGMat',
    Value: {
      Selected: 'selected',
      NotSelected: 'notSelected',
    },
  },
  BusbarAbdeckung: {
    Variable: 'busbarAbdeckung',
    Value: {
      Selected: 'selected',
      NotSelected: 'notSelected',
    },
  },
  Length: {
    Variable: 'length',
  },
  Width: {
    Variable: 'width',
  },
  BorderWidth: {
    Variable: 'borderWidth',
  },
  CellSpacingV: {
    Variable: 'verticalSpacing',
  },
  CellSpacingH: {
    Variable: 'horizontalSpacing',
  },
  CellPower: {
    Variable: 'cellPower',
  },
  ClearConnectorPosition: {
    Variable: 'clearConnectorPosition',
    Value: {
      Top: 'top',
      Aside: 'aside',
    },
    Default: 'aside',
  },
} as const

export const MaterialNames = {
  BackGlas: 'BackGlas',
  BackGlass_Folie_Color_Unichrom_Matt: 'BackGlass_Folie_Color_Unichrom_Matt',
  BackGlass_Folie_Color_Unichrom: 'BackGlass_Folie_Color_Unichrom',
  BackGlass_Folie_Clear_matt: 'BackGlass_Folie_Clear_matt',
  BackGlass_Folie_Clear: 'BackGlass_Folie_Clear',
  FrontGlass_Glossy: 'FrontGlass_Glossy',
  FrontGlass_Matt: 'FrontGlass_Matt',
  FrontGlasFolie_Glossy: 'FrontGlasFolie_Glossy',
  FrontGlasFolie_Matt: 'FrontGlasFolie_Matt',
  Zellen: 'Zellen',
  Zellen_abgedeckt: 'Zellen_abgedeckt',
  Boden: 'Boden',
} as const

export const isEFormClearType = (value?: Value) =>
  value?.key === Keys.EFormType.Value.Clear

export const isEFormUnichromeType = (value?: Value) =>
  value?.key === Keys.EFormType.Value.Unichrome

export const isEFormColorType = (value?: Value) =>
  value?.key === Keys.EFormType.Value.Color
